/* Video-first cards keep their original photo for first paint and the product-page hand-off. Sources stay inert
   until load and a nearby card; one observer discovers proximity, while scroll frames measure the real viewport
   (an observer with a margin cannot tell when half a card is on screen). Re-rendered grids use the same body
   childList / scheduled scan pattern as at-warmup and at-nextpage. */
(function () {
  'use strict';
  var motion = matchMedia('(prefers-reduced-motion: reduce)');
  var connection = navigator.connection;
  var cards = new Map();
  var loaded = document.readyState === 'complete';
  var stopped = false;
  var scheduled = false;
  var stale = true;
  function allowed() {
    return !motion.matches && !(connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || '')));
  }
  function source(video) {
    if (video.hasAttribute('src')) return;
    var sources = JSON.parse(video.dataset.video).sources.filter(function (s) { return s.format === 'mp4' && s.height <= 720; }).sort(function (a, b) { return a.width - b.width; });
    var width = video.clientWidth * devicePixelRatio;
    var best = sources.find(function (s) { return s.width >= width; }) || sources[sources.length - 1];
    if (best) video.src = best.url;
  }
  function visible(video) {
    var r = video.getBoundingClientRect();
    var left = 0, right = innerWidth, top = 0, bottom = innerHeight;
    var rail = video.closest('.at-rail');
    if (rail) {
      var clip = rail.getBoundingClientRect();
      left = Math.max(left, clip.left); right = Math.min(right, clip.right);
      top = Math.max(top, clip.top); bottom = Math.min(bottom, clip.bottom);
    }
    var area = Math.max(0, Math.min(r.right, right) - Math.max(r.left, left)) * Math.max(0, Math.min(r.bottom, bottom) - Math.max(r.top, top));
    return r.width > 0 && r.height > 0 && area / (r.width * r.height) >= 0.5;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) { var state = cards.get(entry.target); if (state) state.near = entry.isIntersecting; });
    schedule();
  }, { rootMargin: innerHeight + 'px 0px', threshold: 0 });
  function scan() {
    stale = false;
    cards.forEach(function (state, video) {
      if (video.isConnected) return;
      video.pause(); observer.unobserve(video); cards.delete(video);
    });
    document.querySelectorAll('.at-card-video').forEach(function (video) {
      if (cards.has(video)) return;
      var state = { near: false, pending: false, blocked: false };
      cards.set(video, state);
      video.muted = true;
      video.addEventListener('playing', function () {
        var reveal = function () { if (!video.paused) video.classList.add('has-frame'); };
        if (video.requestVideoFrameCallback) video.requestVideoFrameCallback(reveal);
        else requestAnimationFrame(reveal);
      });
      video.addEventListener('error', function () { video.classList.remove('has-frame'); state.blocked = true; });
      observer.observe(video);
    });
  }
  function update() {
    scheduled = false;
    if (stale) scan();
    cards.forEach(function (state, video) {
      if (loaded && !stopped && !document.hidden && allowed() && state.near) source(video);
      var poster = video.parentElement.querySelector('img');
      var painted = poster && poster.complete && poster.naturalWidth;
      var play = painted && loaded && !stopped && !document.hidden && allowed() && state.near && !video.closest('[inert]') && visible(video);
      if (!play) {
        video.pause(); state.blocked = false;
        if (!allowed()) video.classList.remove('has-frame');
        return;
      }
      if (!video.hasAttribute('src') || !video.paused || state.pending || state.blocked) return;
      state.pending = true;
      video.play().then(function () { state.pending = false; }, function (error) {
        state.pending = false;
        // An interrupted scroll play can be retried on re-entry; policy/codec failures leave the photo intact.
        state.blocked = error.name !== 'AbortError';
      });
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  new MutationObserver(function (records) {
    if (records.some(function (r) { return r.type === 'childList'; })) stale = true;
    schedule();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['inert'] });
  addEventListener('load', function () { loaded = true; schedule(); }, { once: true });
  addEventListener('scroll', schedule, { capture: true, passive: true });
  addEventListener('resize', schedule, { passive: true });
  document.addEventListener('visibilitychange', schedule);
  document.addEventListener('load', function (event) { if (event.target.matches?.('.at-card-image img')) schedule(); }, true);
  motion.addEventListener('change', schedule);
  if (connection) connection.addEventListener('change', schedule);
  addEventListener('pagehide', function () { stopped = true; cards.forEach(function (_, video) { video.pause(); }); });
  addEventListener('pageshow', function () { stopped = false; schedule(); });
  schedule();
})();
